/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type appGoogleDrive_viewer$ref: FragmentReference;
declare export opaque type appGoogleDrive_viewer$fragmentType: appGoogleDrive_viewer$ref;
export type appGoogleDrive_viewer = {|
  +id: string,
  +company: ?{|
    +id: string,
    +gdriveEnabled: ?boolean,
  |},
  +$refType: appGoogleDrive_viewer$ref,
|};
export type appGoogleDrive_viewer$data = appGoogleDrive_viewer;
export type appGoogleDrive_viewer$key = {
  +$data?: appGoogleDrive_viewer$data,
  +$fragmentRefs: appGoogleDrive_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appGoogleDrive_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "gdriveEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b14dec5a4da96499a92004fc0c33aab2';

module.exports = node;
